import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function getAllEmployee() {
    const res = await fetch(API_ENDPOINT + "employee/get-all/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function newEmployee(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "employee/new-employee", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getSalarySlip() {
    const res = await fetch(API_ENDPOINT + "employee/payment/get/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function employeeSalary(json) {
    json["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "employee/salary", {
        method: "POST",
        body: JSON.stringify(json)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

function getDaysInMonth(year, month) {
    if (month < 0 || month > 11 || isNaN(year) || isNaN(month)) {
        throw new Error("Invalid month or year");
    }
    return new Date(year, month, 0).getDate();
}

export function getDaysInLastMonth() {
    const dt = new Date();
    return getDaysInMonth(dt.getFullYear(), dt.getMonth());
}

export function convertValidMonth(input) {
    // Regex to check for YYYY-MM format
    const match = input.match(/^(\d{4})-(0[1-9]|1[0-2])$/);
    if (!match) return input;
    const date = new Date(`${input}-01`);
    return `${date.toLocaleString('en-US', { month: 'short' })}-${match[1]}`;
}

export function getLastMonth() {
    const dt = new Date();
    let year = dt.getFullYear();
    let month = dt.getMonth();
    if (month === 0) {
        year -= 1;
        month = 11;
    } else {
        month -= 1;
    }
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${monthNames[month]}-${year}`;
}

export function validMonth(date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const match = date.match(/^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{4})$/);
    if (!match) return false;
    const [, monthStr, yearStr] = match;
    const month = monthNames.indexOf(monthStr);
    const year = parseInt(yearStr, 10);
    if (year < 2024 || (year === 2024 && month < 3)) return false; // Since 1-Apr-2025 (April = index 3)
    return true;
}